import {
  ResourceCategoryEnum,
  ResourceTeacherInstruction,
} from '@protos/content_management/content.db_pb';
import { IStyles } from '../../../../commonUtils/styleUtils';
import ElementRenderer from '../../ElementRenderer';
const styles: IStyles = {};
interface IProps {
  teacherInstruction: ResourceTeacherInstruction;
  resourceCategory?: ResourceCategoryEnum;
  disableDownload?: boolean;
  allowUserControls?: boolean;
  openPdfInNewTab?: boolean;
}
export const ResourceTeacherInstructionElement = (props: IProps) => {
  const {
    teacherInstruction,
    resourceCategory,
    disableDownload,
    allowUserControls,
    openPdfInNewTab,
  } = props;
  const elements = teacherInstruction.instructionContent?.elements;
  if (!elements) {
    return null;
  }
  return (
    <ElementRenderer
      disableDownload={disableDownload}
      elements={elements}
      resourceCategory={resourceCategory}
      allowUserControls={allowUserControls}
      openPdfInNewTab={openPdfInNewTab}
    />
  );
};
